<template>
  <common-page-edit
    :title="title"
    :nameRoleEntity="nameRoleEntity"
    :apiNameGet="apiNameGet"
    :apiNameCreate="apiNameCreate"
    :apiNameUpdate="apiNameUpdate"
    :routeNameShow="routeNameShow"
    :routeNameCreate="routeNameCreate"
    :backUrl="pathBack"
   
    :convertLoadData="convertLoadData"
    :paramsSave="paramsSave"

    :isDefaultConverter="false"
    :paramsSend="paramsSend"
    :hasLang="false" 


    @set-loadData="setLoadData"
    @set-sheme="setSheme"
    :readDataFromParent="true"
    :loadDataIn="loadData"
    :schemeIn="scheme"

  >
  </common-page-edit>
</template>
<script>
import { API_METHODS } from "../../../../constant";
import { NAME_OBJECT } from "../../../../RoleConstanans";
import CommonPageEdit from "../../commonElement/CommonPageEdit.vue";
import { api } from "../../../../util/api"
import convertFieldInfoListToScheme from "../../../../helpers/converters/convetFieldInfoListToScheme";
import clearReactive from "../../../../helpers/clearReactive"
import getSchemeComponet from "../../../../helpers/generatorForm/getSchemeComponet";

export default {
  name: "EditPageAttrValueMain",
  components: {
    CommonPageEdit,
  },
  data() {
    return {
      wait: false,
      scheme: {},
      loadData: null,
      fieldInfoList: null,
      preResult: null,
      load: true,

      routeNameShow: null,
      routeNameCreate: null,

      apiNameGet: API_METHODS.GET_ATTR_VALUE,
      apiNameCreate: API_METHODS.CREATE_ATTR_VALUE,
      apiNameUpdate: API_METHODS.UPDATE_ATTR_VALUE,
      loadData: null,
      templateValcodeId: null,
      templateConfig: null,
      blockWatch: true
    };
  },
  computed: {
    title() {
      let text1 = this.$t("Просмотр атрибута");
      let text2 = this.$t("Создание атрибута");
      let text3 = this.$t("Редактирование атрибута");

      let findShow = this.$route.path.indexOf("show");
      if (findShow != -1) {
        return text1;
      }
      let findCreate = this.$route.path.indexOf("create");
      if (findCreate != -1) {
        return text2;
      }
      let findEdit = this.$route.path.indexOf("edit");
      if (findEdit != -1) {
        return text3;
      }
      return text1;
    },
    meta() {
      return this.$route.meta;
    },
    nameRoleEntity() {
      const nameRoute = this.$route.name;
      let role = this.meta.configName
      
      switch (nameRoute) {
          case "agentCreatePagattrvalue":
          case "agentShowPageattrvalue":
          case "agentEditPageattrvalue": {
            role =  NAME_OBJECT.AttrAgency
            break
        }
        case "ClientCreatePagattrvalue":
        case "ClientShowPageattrvalue":
        case "ClientEditPageattrvalue": {
          role =  NAME_OBJECT.AttrClient
          break
        }
      }
      
      return role;
    },
    pathBack() {
      return `/${this.meta.pathBackStart}/${this.$route.params[this.meta.fieldRoute]}/edit`;
    },
    paramsSend() {
      return {
        id: this.$route.params.AttrValueId || "0",
        SubjectId: this.$route.params[this.meta.fieldRoute]
      };
    }
  },
  created() {
    this.routeNameShow = this.meta.routeNameShow;
    this.routeNameCreate = this.meta.routeNameCreate;
  },
  watch: {  
    loadData: {
      deep: true,
      handler(val) {
            
          if(this.templateValcodeId !== val.attrEntityId && val.attrEntityId !== 0 && !this.blockWatch ) {
              this.getTypeValue(val.attrEntityId);
          }
          this.templateValcodeId = val.attrEntityId


      }
    }
  },
  methods: {
    convertLoadData(res) {
      let loadData = res.object;
      let fieldInfoList = res.fieldInfoList;
      let scheme = { configForm: [] };
      this.templateConfig = clearReactive(fieldInfoList[1])
      scheme.configForm = convertFieldInfoListToScheme({
        fieldInfoList,
        hasLang: false
      });
     
     loadData.subjectId = this.$route.params[this.meta.fieldRoute];  
      return {
        loadData,
        fieldInfoList,
        scheme
      };
    },
    setLoadData(loadData) { 
      // debugger
      this.loadData = loadData;
      this.$nextTick(()=>{
         this.blockWatch = false
      })
     
    },
    setSheme(scheme) {
      this.scheme = scheme;
    },
    paramsSave() {
      return {
        id: this.$route.params.AttrValueId || "0",
        SubjectId: this.$route.params[this.meta.fieldRoute]
      };
    },
    async getTypeValue(id) {
      let paramsIn = {
        self: this,
        id: id,
        SubjectId: this.$route.params[this.meta.fieldRoute]
      };
      try {
        let res = await api(
          API_METHODS.GET_TYPE_ATTR_VALUE,
          paramsIn,
          this.$store.state
        );
        let configForm = clearReactive(this.templateConfig) 
        configForm.type = res.object.attrValueType
        let fullSchema = getSchemeComponet(configForm.type, configForm);
        this.loadData.value = null
        this.$delete(this.scheme.configForm, 1);
        this.scheme.configForm.push(fullSchema);
      } catch (e) {
        console.error(e);
      }
    }
  }
};
</script>

